module.exports = __webpack_public_path__ + "img/y_2011.04622de7.png";